import { c as _c } from "react/compiler-runtime";
import { IcoArrowRightSmall16 } from '@onefootprint/icons';
import type { AmlHit } from '@onefootprint/request-types/dashboard';
import { CopyButton, LinkButton, useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useEntityId from '@/entities/components/details/hooks/use-entity-id';
import HitItem from './components/hit-item';
import ProtectedDetails from './components/protected-details';
import useCachedRiskSignalAmlHint from './hooks/use-cached-risk-signal-aml-hint';
import useRiskSignalAmlHits from './hooks/use-risk-signal-aml-hits';
type AmlMatchesProps = {
  riskSignalId: string;
};
const AmlMatches = t0 => {
  const $ = _c(18);
  const {
    riskSignalId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "classicOnboardings.riskSignals.drawer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const entityId = useEntityId();
  const cachedAmlHit = useCachedRiskSignalAmlHint(riskSignalId);
  const decryptMutation = useRiskSignalAmlHits();
  const aml = decryptMutation.data || cachedAmlHit;
  const {
    toast
  } = useToast();
  let t2;
  if ($[1] !== decryptMutation || $[2] !== entityId || $[3] !== riskSignalId || $[4] !== t || $[5] !== toast) {
    t2 = () => {
      decryptMutation.mutate({
        path: {
          fpId: entityId,
          signalId: riskSignalId
        }
      }, {
        onError: () => {
          toast({
            title: t(_temp),
            description: t(_temp2),
            variant: "error"
          });
        }
      });
    };
    $[1] = decryptMutation;
    $[2] = entityId;
    $[3] = riskSignalId;
    $[4] = t;
    $[5] = toast;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleDecrypt = t2;
  if (!aml) {
    let t3;
    if ($[7] !== decryptMutation.isPending || $[8] !== handleDecrypt) {
      t3 = <ProtectedDetails onClick={handleDecrypt} isPending={decryptMutation.isPending} />;
      $[7] = decryptMutation.isPending;
      $[8] = handleDecrypt;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t3;
  if ($[10] !== aml.shareUrl || $[11] !== t) {
    t3 = aml.shareUrl && <div className="flex flex-col w-full max-w-full p-4 rounded bg-secondary"><p className="text-label-2 text-tertiary">{t(_temp3)}</p><div className="flex items-center justify-between w-full max-w-full"><p className="truncate text-body-2">{aml.shareUrl}</p><CopyButton ariaLabel={t(_temp4)} contentToCopy={aml.shareUrl || ""} tooltip={{
          position: "bottom"
        }} /></div><LinkButton iconComponent={IcoArrowRightSmall16} iconPosition="right" variant="label-2" href={aml.shareUrl} target="_blank" className="flex items-center gap-1 mt-5 mb-5 text-label-2 hover:text-accent">{t(_temp5)}</LinkButton></div>;
    $[10] = aml.shareUrl;
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== aml.hits) {
    t4 = aml.hits && aml.hits.length > 0 && <ul className="flex flex-col">{aml.hits.map(_temp6)}</ul>;
    $[13] = aml.hits;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <section className="relative h-full" data-is-decrypted={true}><div className="flex flex-col">{t3}{t4}</div></section>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
export default AmlMatches;
function _temp($) {
  return $.protectedDetails.error.title;
}
function _temp2($_0) {
  return $_0.protectedDetails.error.description;
}
function _temp3($_1) {
  return $_1.sourceUrl.label;
}
function _temp4($_2) {
  return $_2.sourceUrl.ariaLabel;
}
function _temp5($_3) {
  return $_3.sourceUrl.readFullReport;
}
function _temp6(hit) {
  return <HitItem key={JSON.stringify(hit)} hit={hit} />;
}